import { FormattedMessage } from 'react-intl';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'src/registry/ui/Tabs';
import { billingPoliciesMessages } from 'src/features/servicePlanBillingPolicies/utils/messages';
import { pricingPoliciesMessages } from 'src/features/servicePlanPricingPolicies/utils/messages';
import ServicePlanBillingPoliciesTable from 'src/features/servicePlanBillingPolicies/components/tables/ServicePlanBillingPoliciesTable';
import ServicePlanPricingPoliciesTable from 'src/features/servicePlanPricingPolicies/components/tables/ServicePlanPricingPoliciesTable';

type ServicePlanItemDashboardTablesProps = {
    isServicePlanItemActive?: boolean;
};

const ServicePlanItemDashboardTables = ({ isServicePlanItemActive }: ServicePlanItemDashboardTablesProps) => {
    return (
        <div className="grid flex-3 grid-cols-1">
            <Tabs defaultValue="billing-policies">
                <TabsList>
                    <TabsTrigger value="billing-policies">
                        <FormattedMessage {...billingPoliciesMessages.billingPolicies} />
                    </TabsTrigger>
                    <TabsTrigger value="pricing-policies">
                        <FormattedMessage {...pricingPoliciesMessages.pricingPolicies} />
                    </TabsTrigger>
                </TabsList>
                <TabsContent value="billing-policies">
                    <ServicePlanBillingPoliciesTable isServicePlanItemActive={isServicePlanItemActive} />
                </TabsContent>
                <TabsContent value="pricing-policies">
                    <ServicePlanPricingPoliciesTable isServicePlanItemActive={isServicePlanItemActive} />
                </TabsContent>
            </Tabs>
        </div>
    );
};

export default ServicePlanItemDashboardTables;
